// extracted by mini-css-extract-plugin
module.exports = {"cart-items":"Cart_cart-items__3328R","total":"Cart_total__bvsTt","actions":"Cart_actions__1Ti5H","button--alt":"Cart_button--alt__JFBE7","button":"Cart_button__2o0Ao"};